import { Metrics } from '../../../../../constants/Dashboards'
import { EventSpace2ActionTypes } from '../../../../../actions/dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import dwellTimelineGrouped, {DwellTimelineGroupedOutput} from "../../utils/dwellTimelineGrouped";
import {Fixture as LargeVisionFixture} from "../../LargeVision/types";

/**
 * Event Space 2 Dwell Timeline reducer
 */
const EventSpace2DwellTimeline = buildAsyncStatReducer({
  key: Metrics.EVENTSPACE2_DWELLTIMELINE,
  types: EventSpace2ActionTypes.DASHBOARD_EVENTSPACE2_DWELLTIMELINE,
  transform: (state, { payload = {} }): DwellTimelineGroupedOutput => {
    return dwellTimelineGrouped<LargeVisionFixture>(payload)
  },
})

export default EventSpace2DwellTimeline